import { SORT, VIEW, getMask } from './tableLayout'
import DSI from './tableLayoutIndexes'

export const VALUE_TYPE = {
  TITLE: 1,
  OWNER_NAME: 2,
  OWNER_ADDRESS: 3,
  SHARE: 4,
  TAGS: 5,
  OWNER_ABBREV: 6,
  OWNER_CONTRACT_NO: 7,
  OWNER_NEG_STATE: 8,
  OWNER_PHONES: 9,
  OWNER_EMAILS: 10,
  OWNER_NOTES: 11,
  PRICE: 12
}

export const MASS_EDITING_TYPE = {
  NUMBER_INPUT: 1,
  TEXTAREA: 2,
  TAGS: 3,
  ABBREVIATION: 4,
  CONTRACT_NO: 5,
  NEG_STATE: 6,
  PRICE_KU: 7,
  PRICE_BPEJ: 8,
  PRICE_OWN: 9,
  PRICE_T: 10,
  PRICE_DELETE_ONLY: 11
}

const cls1 = 'pl-tv-td'
const cls1_tar = cls1 + ' tar'
const cls1_tac = cls1 + ' tac'
const clsX = 'pl-tv-xx'

export const DS = {
  101: {
    name: '',
    width: 50
  },
  999: {
    name: '',
    width: 20,
    className: clsX
  },
  0: {
    name: 'Obec',
    width: 200,
    className: cls1,
    text: true
  },
  1: {
    name: 'Katastrální území',
    width: 200,
    className: cls1,
    text: true
  },
  2: {
    name: 'Druh číslování'
  },
  3: {
    name: 'Parcelní číslo'
  },
  4: {
    name: 'Podlomení'
  },
  102: {
    name: 'Parcelní číslo',
    type: VALUE_TYPE.TITLE,
    width: 120,
    className: cls1_tac,
    sortable: SORT.PARCEL
  },
  5: {
    name: 'Číslo LV',
    width: 80,
    className: cls1_tac
  },
  6: {
    name: 'Výměra',
    width: 90,
    className: cls1_tar,
    number: true,
    sqMeter: true
  },
  7: {
    name: 'Odkaz na parcelu KN',
    width: 90,
    className: cls1_tac
  },
  8: {
    name: 'Typ parcely',
    width: 100,
    className: cls1,
    text: true
  },
  9: {
    name: 'Zdroj parcely ZE',
    width: 150,
    className: cls1,
    text: true
  },
  10: {
    name: 'Mapový list',
    width: 110,
    className: cls1,
    text: true
  },
  11: {
    name: 'Určení výměry',
    width: 200,
    className: cls1,
    text: true
  },
  12: {
    name: 'Druh pozemku',
    width: 200,
    className: cls1,
    text: true
  },
  13: {
  name: 'Součástí je stavba',
    width: 200,
    className: cls1,
    text: true
  },
  14: {
    name: 'Způsob ochrany nem.',
    width: 200,
    className: cls1,
    text: true
  },
  15: {
    name: 'Seznam BPEJ',
    width: 120,
    className: cls1,
    text: true
  },
  16: {
    name: 'Omezení vlast. práva',
    width: 400,
    className: cls1,
    text: true
  },
  17: {
    name: 'Vlastník - jméno',
    type: VALUE_TYPE.OWNER_NAME,
    width: 300,
    className: cls1,
    sortable: SORT.OWNER
  },
  18: {
    name: 'Vlastník - adresa',
    type: VALUE_TYPE.OWNER_ADDRESS,
    width: 400,
    className: cls1
  },
  19: {
    name: 'Podíl',
    type: VALUE_TYPE.SHARE,
    width: 120,
    className: cls1_tac
  },
  20: {
    name: 'Dotčená plocha',
    width: 90,
    className: cls1_tar,
    number: true,
    sqMeter: true,
    met: MASS_EDITING_TYPE.NUMBER_INPUT
  },
  21: {
    name: 'Vynětí ze ZPF',
    width: 90,
    className: cls1_tar,
    number: true,
    sqMeter: true,
    met: MASS_EDITING_TYPE.NUMBER_INPUT
  },
  22: {
    name: 'Trvalý zábor',
    width: 90,
    className: cls1_tar,
    number: true,
    sqMeter: true,
    met: MASS_EDITING_TYPE.NUMBER_INPUT
  },
  23: {
    name: 'Dočasný zábor',
    width: 90,
    className: cls1_tar,
    number: true,
    sqMeter: true,
    met: MASS_EDITING_TYPE.NUMBER_INPUT
  },
  24: {
    name: 'Plocha výkupu',
    width: 90,
    className: cls1_tar,
    number: true,
    sqMeter: true,
    met: MASS_EDITING_TYPE.NUMBER_INPUT
  },
  25: {
    name: 'Poznámka 1',
    width: 150,
    className: cls1,
    text: true,
    met: MASS_EDITING_TYPE.TEXTAREA
  },
  26: {
    name: 'Poznámka 2',
    width: 150,
    className: cls1,
    text: true,
    met: MASS_EDITING_TYPE.TEXTAREA
  },
  27: {
    name: 'Poznámka 3',
    width: 150,
    className: cls1,
    text: true,
    met: MASS_EDITING_TYPE.TEXTAREA
  },
  28: {
    name: 'Štítky',
    type: VALUE_TYPE.TAGS,
    width: 165,
    className: cls1,
    met: MASS_EDITING_TYPE.TAGS

  },
  29: {
    name: 'Vlastník - zkratka',
    type: VALUE_TYPE.OWNER_ABBREV,
    width: 200,
    className: cls1,
    met: MASS_EDITING_TYPE.ABBREVIATION,
    ownerIndex: 'ab'
  },
  30: {
    name: 'Vlastník - telefon',
    type: VALUE_TYPE.OWNER_PHONES,
    width: 200,
    className: cls1,
    met: MASS_EDITING_TYPE.TEXTAREA,
    ownerIndex: 'te'
  },
  31: {
    name: 'Vlastník - email',
    type: VALUE_TYPE.OWNER_EMAILS,
    width: 200,
    className: cls1,
    met: MASS_EDITING_TYPE.TEXTAREA,
    ownerIndex: 'em'
  },
  32: {
    name: 'Vlastník - poznámky',
    type: VALUE_TYPE.OWNER_NOTES,
    width: 300,
    className: cls1,
    met: MASS_EDITING_TYPE.TEXTAREA,
    ownerIndex: 'no'
  },
  33: {
    name: 'Číslo smlouvy',
    type: VALUE_TYPE.OWNER_CONTRACT_NO,
    width: 150,
    className: cls1_tac,
    met: MASS_EDITING_TYPE.CONTRACT_NO,
    ownerIndex: 'cn'
  },
  34: {
    name: 'Stav projednání',
    type: VALUE_TYPE.OWNER_NEG_STATE,
    width: 165,
    className: cls1,
    met: MASS_EDITING_TYPE.NEG_STATE,
    ownerIndex: 'sn'
  },
  35: {
    name: 'Výměry BPEJ',
    width: 120,
    className: cls1,
    text: true
  },
  36: {
    name: 'Cena KÚ parcela',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_DELETE_ONLY
  },
  37: {
    name: 'Cena KÚ akce',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_KU
  },
  38: {
    name: 'Cena BPEJ parcela',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_DELETE_ONLY
  },
  39: {
    name: 'Cena BPEJ akce',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_BPEJ
  },
  40: {
    name: 'Cena vlastní parcela',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_DELETE_ONLY
  },
  41: {
    name: 'Cena vlastní akce',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_OWN
  },
  42: {
    name: 'Cena zvolená',
    type: VALUE_TYPE.PRICE,
    width: 90,
    className: cls1_tar,
    number: true,
    money: true,
    met: MASS_EDITING_TYPE.PRICE_T
  },
  43: {
    name: 'Poznámka k ceně 1',
    width: 150,
    className: cls1,
    text: true,
    met: MASS_EDITING_TYPE.TEXTAREA
  },
  44: {
    name: 'Poznámka k ceně 2',
    width: 150,
    className: cls1,
    text: true,
    met: MASS_EDITING_TYPE.TEXTAREA
  }
}

export const PRICE_DATA = {
  36: {
    U: 0,   // unit price
    DU: '', // date of unit price
    I: 1,   // index
    DI: '', // date of index
    T: '',  // total
    D: ''   // date
  },
  // 37: { 
  //   T: ''   // Total
  //  },
  38: {
    bpej_default: {
      A: 0,    // area
      U: 0,    // unit prices
      I: 1,    // index
      T: '',   // total
      DI: ''   // date of index
    },
    T: ''      // total
  },
  // 39: { 
  //   T: ''
  // },
  40: {
    U: 0,   // unit price
    UT: 0,  // unit total (unit * area)
    OT: 0,  // own total
    M: 0,   // method: 0 = ST, 1 = OT
    T: ''   // total
  }
  // 41: {
  //   T: ''   // TOTAL
  // },
  // 42: {
  //   M: '', // METHOD relative to first price!
  //   T: ''   // TOTAL
  // }
}

export const getColumns = () => {
  let columns = [
    {
      name: DS[0].name,
      index: 0
    },
    {
      name: DS[1].name,
      index: 1
    },
    {
      name: DS[102].name,
      index: 102
    }
  ]
  for (let i = 5; i <= DSI.BD_MAX; i++ ) {
    columns.push({
      name: DS[i].name,
      index: i
    })
  }
  return columns
}

export const getColumnsIndexes = () => {
  let indexes = [0, 1, 102]
  for (let i = 5; i <= DSI.BD_MAX; i++ ) {
    indexes.push(i)
  }
  return indexes
}

const csw = width => {
  const val = `${width}px`
  return (
    {
      width: val,
      minWidth: val,
      maxWidth: val
    }
  )
}

export const getStyle = item => {
  if (!item) {
    return csw(DS[101].width)
  }
  return csw(item.width)
}

export const resolveType = (item, title, owner, share, value) => {
  switch (item.type) {
    case VALUE_TYPE.TITLE:
      return title
    case VALUE_TYPE.OWNER_NAME:
      return owner.n
    case VALUE_TYPE.OWNER_ADDRESS:
      return owner.a
    case VALUE_TYPE.SHARE:
      return share
    case VALUE_TYPE.OWNER_ABBREV:
      return owner.ab
    case VALUE_TYPE.OWNER_CONTRACT_NO:
      return owner.cn
    case VALUE_TYPE.OWNER_NEG_STATE:
      return owner.sn
    case VALUE_TYPE.OWNER_PHONES:
      return owner.te
    case VALUE_TYPE.OWNER_EMAILS:
      return owner.em
    case VALUE_TYPE.OWNER_NOTES:
      return owner.no
    case VALUE_TYPE.PRICE:
      return value.T
    default:
      return undefined
  }
}

const computeFullWidth = () => {
  let w = 0
  for (let key in DS) {
    const iw = DS[key].width
    if (iw) {
      w += iw
    }
  }
  return w
}

const computeWidth = mask => {
  let w = DS[101].width
  for (let i = 0; i < mask.length; i++) {
    w += DS[mask[i]].width
  }
  return w
}

export const getTableWidth = (sorted, view) => {
  if (view === VIEW.FULL) {
    return computeFullWidth()
  }
  return computeWidth(getMask(sorted, view))
}

export const createTitle = data => `${data[2] || ''} ${data[3]
  || ''}${data[4] ? `/${data[4]}` : ''}`



// WEBPACK FOOTER //
// ./src/config/parcelDataScheme.js